const mainTag = 'docteur'
const spesificTag = 'docteur_rdv'

const OneGConf = {
    OneLocalStorage: JSON.parse(localStorage.getItem('Docteur_rdv')),  
    forPID: JSON.parse(localStorage.getItem(`ProfileData`)),  
    themeMode: localStorage.getItem(`${mainTag}_${spesificTag}_Theme`),
    oneOffline : JSON.parse(localStorage.getItem(`${mainTag}_${spesificTag}_offline`)),
    
    themeColor: '#2f8d99',
    default_Offline : {patientListe: [], rdvListe: [], rdvToSave:[] }, 
    routerName : 'C',
    routerTagName : `${mainTag}_${spesificTag}`,
    topBarName : 'T_Name',

    loginData : {
        tableToLgIn : '01_docteur_team',
        Identifiant : 'Identifiant',
        Password : 'Password',
        LogId : 'Now_Login_ID',
        ID_Tag : 'T_ID'
    },

    main : [
        {id:1, link:'/cl', icon:'person', text:'PATIENT', desc:''},
        {id:4, link:'/rq', icon:'person-plus', text:'AJOUTER PATIENT', desc:''},
        {id:2, link:'/sa', icon:'calendar-check', text:'RENDY-VOUS', desc:''},
        {id:3, link:'/finance', icon:'calendar-week', text:'CALENDRIER', desc:''}, 
    ],

    //return back card 
    backCard:{
        clad : {id:1, text:'Nouveaux Patient', link:'/C/L'},
        ca : {id:9, text:'Liste Des Patient', link:'/C/L'},
        rdv : {id:9, text:'Rendy Vous', link:'/C/L'},
        rdvInf : {id:9, text:'Info de Rendy-Vous', link:'/C/L'},
        cld : {id:9, text:'Calendrier', link:'/C/L'},
        up : {id:9, text:'Mise à Jour', link:'/C/L'},
        rt : {id:1, text:'Recette', link:'/C/L'},
        nv : {id:1, text:'Nouveaux Facture', link:'/C/L'},
        pann : {id:1, text:'Nouveaux Facture', link:'/C/L'},

        mf : {id:7, text:'Mes Factures', link:'/C/L'},
        mfInfo : {id:8, text:'Facture Info', link:'/C/L'},
        mfEdit : {id:8, text:'Modifier Facture', link:'/C/L'},
       
        sk : {id:9, text:'Stock', link:'/C/L'},
        skList : {id:10, text:'Mon Stock', link:'/C/L'},
        skInfo : {id:12, text:'Info Sur Article', link:'/C/L'},
        skfamilleList: {id:13, text:'Mon Stock', link:'/C/L'},
        skFond: {id:13, text:'Fonds', link:'/C/L'},
        skFondD: {id:14, text:'Fonds Info', link:'/C/L'},

        vt : {id:1, text:'Mes Ventes', link:'/C/L'},
        vtRech : {id:1, text:'Recherche', link:'/C/L'},
        vtJour : {id:1, text:'Aujourd\'hui', link:'/C/L'},

        cl : {id:2, text:'Client', link:'/C/L'},
        clAdd : {id:3, text:'Ajouter Client', link:'/C/L'},
        clPtg : {id:4, text:'Pointage des Clients', link:'/C/L'},
        clMap : {id:5, text:'Recherche des Clients', link:'/C/L'},
        clList : {id:6, text:'Liste des Clients', link:'/C/L'},

        rt : {id:1, text:'Recette', link:'/C/L'},
        rtDeps : {id:1, text:'Depenses', link:'/C/L'},
        rtImpr : {id:1, text:'Imprimer', link:'/C/L'},

        up : {id:1, text:'Mettre a jour ', link:'/C/L'},


    },
    offlineData : [
        {genreName : 'patientListe', textName:'Liste des Patient', tableName:'01_docteur_patient', offLineValue:'patientListe'},
        {genreName : 'rdvListe', textName:'Liste des RendyVous',  tableName:'01_docteur_calendar', offLineValue:'rdvListe'},
    ]
     
}
export default OneGConf